import axios from 'axios'
import { isNil, replace } from 'lodash/fp'
import { v4 } from 'uuid'

import { FormInputDatas } from '../../types'
import log from 'loglevel'
import { inspect } from './inspect'
import { httpRequest } from '../../functions/common'
// import { createHash } from './api'

log.setLevel(log.levels.DEBUG)

const env = process.env['REACT_APP_ENV'] ?? 'dev'

const baseName = 'terashite.jp'
const zoneName = `${
  { prd: '', stg: '', int: 'dev.', dev: 'dev.', exp: 'dev.' }[env] as string
}${baseName}`
const domainName = `api${
  { prd: '', stg: '-stg', int: '-int', dev: '', exp: '-exp' }[env] as string
}.terashite-entry.${zoneName}`

export const getIsCreditRegistered = async (id: string) => {
  const result = await axios.get(
    `https://${domainName}/v1/request/is-credit-regist/${id}`
  )
  if (isNil(result)) {
    return undefined
  }
  return result
}

export const createMemberId = () => `${env !== 'dev' ? 'TER' : 'DTER'}${replace(/[-]/g, '')(v4())}`

export const sendRequestData = async (
  data: FormInputDatas
): Promise<boolean> => {
  // const subHash = await createHash('SHA-256', sub)
  // const sendData = {
  //   sub: subHash,
  //   ...data
  // }
  const result = await httpRequest(
    'post',
    `https://${domainName}/v1/entry`,
    data
  )
  if(isNil(result)) {
    log.error('[functions.sendRequestData] cannot create entry')
    return false
  }
  if (result.status === 202) {
    return true
  }
  log.error(`[functions.sendRequestData]`, inspect(result))
  return false
}
